import axios from 'axios';

export default axios.create({
    baseURL: 'https://www.strava.com/api/v3/athlete/'
})